import { render, staticRenderFns } from "./AppRoot.vue?vue&type=template&id=0bc0d2f0&"
import script from "./AppRoot.vue?vue&type=script&lang=js&"
export * from "./AppRoot.vue?vue&type=script&lang=js&"
import style0 from "./AppRoot.vue?vue&type=style&index=0&id=0bc0d2f0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bc0d2f0')) {
      api.createRecord('0bc0d2f0', component.options)
    } else {
      api.reload('0bc0d2f0', component.options)
    }
    module.hot.accept("./AppRoot.vue?vue&type=template&id=0bc0d2f0&", function () {
      api.rerender('0bc0d2f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AppRoot.vue"
export default component.exports